/** Support tickets (ADR-0069): the last entry of the Validation group,
 *  Administrators only. A ticket is `${TICKETS_PATH}/<ticket id>`. */
export const TICKETS_PATH = "/solutions/validation/tickets";
